/**
 * [CONTAINER-START]
 * CONTAINER-TYPE: configuration
 * CONTAINER-CLASS: infrastructure
 * ROUTE: N/A (Config only)
 * NAV-LABEL: Tram Stops Registry
 * TG-SOLUTION-ID: 100
 * DESCRIPTION: Central registry of all tram stops (platforms) in the ecosystem
 * DEPENDENCIES: None
 * CONTAINER-STATUS: mvp-production
 * CONTAINER-VERSION: 1.0.0
 * [CONTAINER-END]
 */

export interface TramStop {
    id: string;
    name: string;
    welcomeCenterRoute: string;
    elevatorComponent: string;
    description: string;
    isActive: boolean;
    platform: 'commercial' | 'public' | 'mixed';
    floors: string[];
}

/**
 * Central Registry of all Tram Stops (Platforms)
 *
 * Pattern for adding new destinations:
 * 1. Add entry to tramStops array
 * 2. Create src/[DestinationName]/ folder structure
 * 3. Create MainStreet/WelcomeCenters/[DestinationName]Welcome/
 * 4. Create [DestinationName]/Elevator.tsx
 * 5. Build floors following platform pattern
 */
export const tramStops: TramStop[] = [
    {
        id: 'techgacity-center',
        name: 'Techgacity Center',
        welcomeCenterRoute: '/welcome/techgacity',
        elevatorComponent: 'TechgacityCenter/Elevator',
        description: 'Enterprise business platform - Universal ERP, Collaboration, BI',
        isActive: true,
        platform: 'commercial',
        floors: [
            'Floor 00 - Marketing Sites',
            'Floor 01 - Food Court & Bookstore',
            'Floor 02 - Collaboration Center',
            'Floor 03 - My Office (Tenant UI)',
            'Floor 04 - Infrastructure (DataLake, Universal Office, Engineering Lab)',
        ],
    },
    {
        id: 'life-center-village',
        name: 'Life Center Village',
        welcomeCenterRoute: '/welcome/lifecenter',
        elevatorComponent: 'LifeCenterVillage/Elevator',
        description: 'Community platform - Public spaces, Events, Meetups, Life Groups',
        isActive: true,
        platform: 'public',
        floors: [
            'Floor 00 - Public Spaces',
            'Floor 01 - Theater & Bandstand',
            'Floor 02 - Meeting Spaces',
            'Floor 03 - My Life Center (Personal Dashboard)',
        ],
    },
    // Future destinations will be added here:
    // - Innovation Campus
    // - Education Center
    // - Healthcare Hub
    // - Supply Chain Command Center
    // - etc.
];

/**
 * Get tram stop by ID
 */
export const getTramStop = (id: string): TramStop | undefined => {
    return tramStops.find((stop) => stop.id === id);
};

/**
 * Get all active tram stops
 */
export const getActiveTramStops = (): TramStop[] => {
    return tramStops.filter((stop) => stop.isActive);
};

/**
 * Get tram stops by platform type
 */
export const getTramStopsByPlatform = (platform: 'commercial' | 'public' | 'mixed'): TramStop[] => {
    return tramStops.filter((stop) => stop.platform === platform && stop.isActive);
};
